<template>
  <v-slide-y-transition mode="out-in">    
    <v-container bg fill-height grid-list-md text-xs-center style="height:85vh; position: absolute" v-if="firsttime && loading">
      <v-layout row wrap align-center>
        <v-flex>
          <v-progress-circular
            :size="110"
            :width="7"
            :color="$config.color"
            indeterminate>
            Loading...
          </v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid class="mb-4 pa-3" v-else>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-toolbar>            
            <v-text-field
              flat
              solo
              append-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
            ></v-text-field>
            <v-tooltip bottom>
              <v-btn slot="activator" :loading="loading" icon @click="setKompetisi(true)">
                <v-icon>refresh</v-icon>            
              </v-btn>
              <span>Refresh</span>
            </v-tooltip>  
            <v-spacer></v-spacer>            
            <v-chip dark v-bind:color="quickcountMode?'warning':'success'">
              <v-switch v-model="quickcountMode" v-bind:true-value="true" v-bind:false-value="false" class="mb-1" hide-details              
              ></v-switch> {{quickcountMode ? 'Quickcount':'Realcount'}}
            </v-chip>   
          </v-toolbar>
          <v-progress-linear color="info" :indeterminate="true" v-if="loading && !offtime" height="5" class="ma-0"></v-progress-linear>
        </v-flex>
        <v-flex lg12 sm12 xs12>
          <v-container grid-list-lg fluid pa-0 mt-3>
            <v-layout row wrap>
              <v-flex lg6 sm6 xs12 v-for="(item, i) in kompetisi.data">
                <v-card>
                  <v-toolbar v-bind:color="item.color" flat dark dense card>
                    <v-toolbar-title><h5>{{item.name}}</h5></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <slot name="widget-header-action">{{item.sah.updated_at?$moment(item.sah.updated_at*1000).fromNow():null}}</slot>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <v-card-text class="pa-1 pb-0" v-if="item.mode == 1">
                    <e-chart :key="'a'+kompetisi.time" v-if="!quickcountMode" v-bind:option="setPieOption(item)" height="250px" width="100%"/>                  
                    <e-chart :key="'b'+kompetisi.time" v-else v-bind:option="setPieOption(item, true)" height="250px" width="100%"/>                                        
                  </v-card-text>
                  <v-card-text class="pa-1 pb-0" v-if="item.mode == 2">
                    <e-chart :key="'c'+kompetisi.time" v-if="!quickcountMode" v-bind:option="setDonutOption(item)" height="250px" width="100%"/>                  
                    <e-chart :key="'d'+kompetisi.time" v-else v-bind:option="setDonutOption(item, true)" height="250px" width="100%"/>                                        
                  </v-card-text>
                  <v-card-text class="pa-1 pb-0" v-if="item.mode == 3">
                    <e-chart :key="'e'+kompetisi.time" v-if="!quickcountMode" v-bind:option="setBarOption(item)" height="250px" width="100%"/>                  
                    <e-chart :key="'f'+kompetisi.time" v-else v-bind:option="setBarOption(item, true)" height="250px" width="100%"/>                                        
                  </v-card-text>                
                  <v-card-text class="pt-0"  v-if="!quickcountMode">
                    <table style="width:100%">
                      <tr><td class="text-xs-left"><span class="title blue--text"><v-icon color="blue">accessibility</v-icon> {{item.sah.sah?item.sah.sah:0}}</span>/<small>{{item.pt?item.pt:0}} &nbsp; telah memilih</small></td>
                        <td class="text-xs-right"><small>tidak sah </small><span class="title red--text">{{item.sah.tdk_sah?item.sah.tdk_sah:0}}  <v-icon color="red">layers_clear</v-icon></span></td>
                      </tr>
                    </table>                    
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <router-link :to="hitungRoute(item)"><v-btn dark v-bind:color="item.color">Input Data</v-btn></router-link>
                    <v-spacer></v-spacer>
                    <span :class="colorPersen(persenContain(item.contain))+'--text'"><v-icon small :color="colorPersen(persenContain(item.contain))">trending_up</v-icon> {{persenContain(item.contain)}}%</span>                            
                  </v-card-actions>
                </v-card>                
              </v-flex>
              <v-flex lg6 sm6 xs12 v-if="kompetisi.data.length < kompetisi.count">
                <v-btn class="my-0" block color="info" :loading="loading" small dark @click="setKompetisi()">load more ...</v-btn>
              </v-flex>
              <v-flex lg6 sm6 xs12 v-if="empty">
                <span class="display-1">No Data Result</span>
              </v-flex>
            </v-layout>    
          </v-container>  
        </v-flex>
      </v-layout>      
    </v-container>    
  </v-slide-y-transition>
</template>

<script>  
import EChart from '@/components/chart/echart';  
import DPie   from '../../components/data-chart/pie-1';
import DBar   from '../../components/data-chart/bar-1';
import DDonut from '../../components/data-chart/donut-1';

import Model  from '@/apps/frc/models/Dashboard';  
const  model  = new Model();
export default {  
  components: {
     EChart
  },
  data: () => ({        
    quickcountMode:false, ke:0,   
    search:null,
    kompetisi:{data:[],count:0,page:1,time:null},
    loading : false,
    firsttime : true,
    offtime : true,
    empty : false,
    optionPie : {
        
    }
  }),  
  mounted(){ this.init() },
  created(){
   
  },
  computed: {
    color () {      
      return this.kompetisis[this.bottomNav] ? this.kompetisis[this.bottomNav].color : 'white';
      /*switch (this.bottomNav) {
        case 0: return 'blue-grey'
        case 1: return 'teal'
        case 2: return 'brown'
        case 3: return 'indigo'
      }*/
    }
  },
  watch: {
    search(newVal){
      const ctx=this; setTimeout(function(){
         if(newVal === ctx.search){
            ctx.setKompetisi(true);
         }
      },700);      
    }
  },
  methods: {  
    init(){  
      this.loading = true;
      model.allOfflinePromise('kompetisi').then(data=>{
        if(data.length > 0){
          this.kompetisi.data = data;                
          this.kompetisi.page++;        
          this.kompetisi.count = data.length;           
          this.kompetisi.time  = this.$moment().valueOf();           
          this.loading   = false;
          this.firsttime = false;   
          const ctx = this; setTimeout(function(){
            ctx.setKompetisi(true);
          }, 1000);
        }else {
          this.setKompetisi(true);                                       
        }        
      });      
    },
    
    persenContain(contain){
        return this.quickcountMode ? (contain.quick/contain.all*100).toFixed(2):(contain.done/contain.all*100).toFixed(2);
    },
    
    colorPersen(persen){
        if(persen >= 0 && persen <=40)return 'red';
        else if(persen <=60)return 'orange';
        else if(persen <=80)return 'yellow';
        else if(persen <=99)return 'blue';
        else return 'green';        
    },
    
    setKompetisi(reset = false){
      this.loading = true; this.empty=false;         
      if(reset) {this.kompetisi.page = 1;}      
      model.kompetisis({'KompetisiSearch[name]':this.search, page:this.kompetisi.page,}).then(resp=>{   
        if(resp.status !== 200 || (!resp.data || !resp.data.data)){          
          this.loading = false; this.empty = true;         
          return;
        }
        if(reset) {this.kompetisi.data = []; this.kompetisi.page = 1; this.kompetisi.count=0;
            model.resetOffline('kompetisi');
            model.createOrUpdateOffline('kompetisi', resp.data.data);
        }                                  
        this.kompetisi.data = [...this.kompetisi.data, ...resp.data.data];                
        this.kompetisi.page++;        
        this.kompetisi.count = resp.data.count;           
        this.kompetisi.time  = resp.data.time;           
        this.loading   = false;
        this.firsttime = false;
        this.offtime = false;
        if(!this.kompetisi.data.length){
          this.empty = true;
        }
      });             
    },
    
    setPieOption(data, quickcountMode=false){
      let newOption  = JSON.parse(JSON.stringify(DPie.option));
      let seriesData = [], legendData = [];        
      data.calons.forEach(item=>{
          var value = quickcountMode?item.hitung.quickcount:item.hitung.suara;   
          value = value > 0 ? value :null;
          var name  = item.no+'. '+item.akronim;
          seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
          legendData.push(name);
      });
      newOption.series[0].data = seriesData;      
      newOption.legend.data    = legendData;      
      //console.log(newOption);
      return newOption;
    },
    
    setBarOption(data, quickcountMode=false){      
      let newOption  = JSON.parse(JSON.stringify(DBar.option)); 
      let seriesData = [], legendData = [];  
      data.calons.forEach(item=>{
          var value = quickcountMode?item.hitung.quickcount:item.hitung.suara;  
          value = value > 0 ? value :null;
          var name  = item.no+'.'+item.name;
          seriesData.push({name:name, value:value, itemStyle: {color:item.color}});
          legendData.push(item.no);
      });
      newOption.series[0].data = seriesData;      
      newOption.xAxis[0].data  = legendData;      
      //console.log(newOption);
      return newOption;
    },        
    
    setDonutOption(data, quickcountMode=false){      
      var newOption = JSON.parse(JSON.stringify(DDonut.option));      
      let legendData = [];
      var n = data.calons.length;
      var size = (120/(n+1));
      data.calons.forEach((dapil,i)=>{
        let seriesData = [];   
        if(dapil){
          dapil.calons.forEach((item)=>{  
            var value = quickcountMode?item.hitung.quickcount:item.hitung.suara; 
            value = value > 0 ? value :null;
            if(value){
              var name  = item.partai.akronim;
              seriesData.push({name:name, value:value, itemStyle: {color:item.color}});              
            }                  
            if(item.partai && !legendData.includes(item.partai.akronim)){
              legendData.push(item.partai.akronim);
            }
          });
          if(seriesData.length > 0){
            var defSeries = JSON.parse(JSON.stringify(DDonut.series));
            defSeries.name = dapil.name;
            defSeries.data = seriesData;
            defSeries.radius = [(i*size)+size,(i*size)+(size+size)];
            newOption.series.push(defSeries);
          }
        }        
      });        
      newOption.legend.data    = legendData;            
      return newOption;
    },
    
    
    hitungRoute(item){
      return {path:'/hitung', query:{kompetisi_id:item.id,tingkat:item.tingkat}};
    }
  }
}
</script>